import { Button, Classes, Dialog, Intent } from '@blueprintjs/core';
import React, { useEffect, useState } from 'react';

interface ConfirmationDialogProps {
  isOpen: boolean;
  onCancel?: () => void;
  onContinue: () => void;
  title: string;
  message?: string;
  messageContent?: JSX.Element;
  confirmText: string;
  confirmIntent?: Intent;
  cancelText?: string;
  canOutsideClickClose?: boolean;
}

export const ConfirmationDialog = ({
  isOpen,
  onCancel,
  onContinue,
  title,
  message = '',
  messageContent,
  confirmText,
  confirmIntent = Intent.SUCCESS,
  cancelText,
  canOutsideClickClose = false,
}: ConfirmationDialogProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(isOpen);

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const handleContinue = () => {
    onContinue();
    closeDialog();
  };

  const handleCancelAction = () => {
    if (onCancel !== undefined) onCancel();
    closeDialog();
  };

  useEffect(() => {
    if (isOpen) {
      openDialog();
    } else {
      closeDialog();
    }
  }, [isOpen]);

  return (
    <>
      <Dialog isOpen={isDialogOpen} title={title} isCloseButtonShown={false} canOutsideClickClose={canOutsideClickClose} style={{ width: '800px' }}>
        <div className={Classes.DIALOG_BODY}>{messageContent !== undefined ? messageContent : message}</div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button onClick={handleContinue} intent={confirmIntent}>
              {confirmText}
            </Button>
            {onCancel && (
              <Button onClick={handleCancelAction} intent={Intent.PRIMARY}>
                {cancelText}
              </Button>
            )}
          </div>
        </div>
      </Dialog>
    </>
  );
};
